<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Tür</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
             <input type="text" v-model="value.Name" class="form-control" placeholder="Tür" />
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Simge</label>
            <v-validator :errors="errors" parameter="Icon" :watch="icon">
                <v-select :options="icons" v-model="icon" label="icon" placeholder="Simge">
                    <template v-slot:option="option">
                        <div class="d-flex align-items-center">
                            <span class="material-icons-round mr-50">{{option.icon}}</span>
                        </div>
                    </template>
                    <template #selected-option="option">
                        <span class="material-icons-round mr-50">{{option.icon}}</span>
                    </template>
                </v-select>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Renk</label>
            <v-validator :errors="errors" parameter="Color" :watch="color">
                <v-select :options="colors" v-model="color" label="name" placeholder="Renk">
                    <template v-slot:option="option">
                        <div class="d-flex align-items-center">
                            <div class="color bl rounded mr-50" :class="option.class"></div>
                            {{option.name}}
                        </div>
                    </template>
                    <template #selected-option="option">
                        <div class="color bd rounded mr-50" :class="option.class"></div>
                        {{option.name}}
                    </template>
                </v-select>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Çalışma Gün Türü</label>
            <v-validator :errors="errors" parameter="EmployeeWorkingTypeId" :watch="type">
                <v-select-list v-model="type" :options="types" label="Name"  placeholder="Çalışma Gün Türü"></v-select-list>
            </v-validator>
            </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.IsDocumentRequired">Dosya Gerekli</b-form-checkbox>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.PrimaryExcuse">RT Öncelikli İzin</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
export default {
    components:{
        BFormCheckbox,
    },
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getTypes()
    },
    data(){
        return{
            types:[],
            colors:[
                {name:"Mavi",class:"bg-light-primary"},
                {name:"Açık Mavi",class:"bg-light-info"},
                {name:"Yeşil",class:"bg-light-success"},
                {name:"Sarı",class:"bg-light-warning"},
                {name:"Turuncu",class:"bg-light-secondary"},
                {name:"Kırmızı",class:"bg-light-danger"},
            ],
            icons:[
                {icon:'label_important'},
                {icon:'upcoming'},
                {icon:'reply_all'},
                {icon:'send_time_extension'},
                {icon:'cake'},
                {icon:'pregnant_woman'},
                {icon:'baby_changing_station'},
                {icon:'child_care'},
                {icon:'grass'},
                {icon:'holiday_village'},
                {icon:'beach_access'},
                {icon:'tsunami'},
                {icon:'umbrella'},
                {icon:'smoking_rooms'},
                {icon:'car_crash'},
                {icon:'mosque'},
                {icon:'church'},
                {icon:'temple_buddhist'},
                {icon:'wine_bar'},
                {icon:'money_off'},
                {icon:'gavel'},
                {icon:'medication'},
                {icon:'watch_later'},
            ]
        }
    },
    methods:{
        getTypes(){
            EmployeeOperationsApi.Score.WorkingType().then(res=>{
                this.types = res.data.Data
            })
        }
    },
    computed:{
        color:{
            get:function(){
                return this.colors.find(b=>b.class==this.value.Color)
            },
            set:function(value){
                this.value.Color = value?.class || null
            }
        },
        icon:{
            get:function(){
                return this.icons.find(b=>b.icon==this.value.Icon)
            },
            set:function(value){
                this.value.Icon = value?.icon || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.EmployeeWorkingTypeId)
            },
            set:function(value){
                this.value.EmployeeWorkingTypeId = value?.Id || null
            }
        }
    }
}
</script>

<style>
    .color{
        width: 50px;
        height: 20px;
    }
    .color.bl{
        border: 1px solid white;
    }
    .color.bd{
        border: 1px solid rgb(224, 224, 224);
    }
</style>